import script from "./CommentsListLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsListLoader.vue?vue&type=script&setup=true&lang=js"

import "./CommentsListLoader.vue?vue&type=style&index=0&id=50c29d30&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c29d30"]])

export default __exports__